import animateScrollTo from 'animated-scroll-to';

export default class Hero {

  constructor() {
    const cta = document.querySelector('#hero-cta');
    const target = document.querySelector('#upload');
    if (!cta) {
      return;
    }

    cta.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      window.scrollTo(0, document.body.scrollHeight);

      setTimeout(() => {
        const bodyRect = document.body.getBoundingClientRect();
        const elemRect = target.getBoundingClientRect();
        const _options = {
          minDuration: 750,
          maxDuration: 3000,
          verticalOffset: -24,
        };
        animateScrollTo((elemRect.top - bodyRect.top), _options);
      }, 100);
    });

  }

}
